import React from 'react';
export function EmotionalTransition() {
  return <section className="bg-blue-900 py-16 px-4 text-center" data-id="element-55">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-56">
        <p className="text-xl md:text-2xl text-blue-100" data-id="element-57">
          Lo sappiamo bene. Insegnare yoga ai bambini è una delle esperienze più
          gratificanti che esistano, ma anche una delle più impegnative. Hai
          bisogno di creatività, pazienza, struttura e tantissime risorse — e
          spesso ti ritrovi a partire da zero ogni settimana.
        </p>

        <p className="text-2xl md:text-3xl text-white font-bold" data-id="element-58">
          Ma non deve essere così. Non devi più passare le tue serate a cercare
          idee, costruire sequenze da capo o inventare giochi all'ultimo
          momento. Esiste un modo più intelligente, più semplice e infinitamente
          più divertente — sia per te che per i tuoi piccoli allievi.
        </p>

        <p className="text-xl text-blue-200" data-id="element-59">
          Immagina di aprire un'unica raccolta e trovare già tutto pronto:
          lezioni, posizioni, storie, giochi, musiche e schede da stampare.
          Tutto pensato per i bambini, tutto testato in classe, tutto pronto da
          usare oggi stesso.
        </p>
      </div>
    </section>;
}